import {EntryDescStateType} from 'module/edesc/reducer/EntryDescReducer';
import {createSelector} from 'reselect'
import {selPropGenString} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {ById} from 'util/redux/ReduxHelperTypes'
import {EntryDesc} from 'generated/JavaTOmodifications'
import {Perm, TypePerm} from 'module/edesc/TypePerm'

export const selEntryDescById = (state: EntryDescStateType) => state.EntryDesc.byId
export const selEntryDescAllIds = (state: EntryDescStateType) => state.EntryDesc.allIds
export const selEntryDescFav = (state: EntryDescStateType) => state.EntryDesc.fav
export const selEntryDescFavEditMode = (state: EntryDescStateType) => state.EntryDesc.favEditMode

type PropertyEntryTypeList = [string, string?][]

export function transformPropertyEntryTypeList(p: string | null, entryDescById: ById<EntryDesc>): number[] {
	const typesFromProp = p?.split(';')
		.map(x => x?.split('/').slice(0, 2).filter(x => x) || [])
		.filter(x => x.length === 1 || x.length === 2) as PropertyEntryTypeList
	if (!typesFromProp) return []
	const entryDescs = [...Object.values(entryDescById)]
	const edFiltered = typesFromProp.flatMap(t => entryDescs.filter(ed => t[0] === ed.bookingType && (!t[1] || ed.hourCategory === t[1])))
	return [...new Set(edFiltered.map(x => x.id))]
}

export function transformPropertyEntryTypeGroupedList(p: string | null, entryDescById: ById<EntryDesc>): number[][] {
	return p?.split('<>').map(group => transformPropertyEntryTypeList(group, entryDescById)) || []
}

export const selEntryDescIdsToSortItemsAlwaysOn = createSelector(
	selPropGenString(PropID.sortAlwaysOnTop),
	selPropGenString(PropID.sortAlwaysOnBottom),
	selEntryDescById,
	(top, bottom, entryDescById) => ({
		top: top ? transformPropertyEntryTypeList(top, entryDescById) : [],
		bottom: bottom ? transformPropertyEntryTypeList(bottom, entryDescById) : [],
	}),
)

export const selCreatePermExists = createSelector(
	selEntryDescById,
	(entryDescById) => {
		const entryDescList = Object.values(entryDescById)
		const others = entryDescList.some(ed => TypePerm.check(ed, Perm.crt, false))
		const selfAdmin = entryDescList.some(ed => TypePerm.check(ed, Perm.crt, true))
		return {others, selfAdmin}
	},
)